import type {
  CountableApiResponse,
  CreateManualRecordDto,
  SerializedManualRecord,
  SerializedMeter,
  UpdateManualRecordDto,
} from '@enmon/commons/lib/enmon';
import { BaseApiClient } from '../baseApiClient';
import { joinIfArray } from 'utils/array';

export interface ManualRecordsFilter {
  meters?: Array<SerializedMeter['_id']>;
  page?: number;
  pageSize?: number;
}

export type GetManualRecordsArgs = ManualRecordsFilter;
export type GetManualRecordsResponse = CountableApiResponse<SerializedManualRecord[]>;

export interface CreateManualRecordArg {
  payload: CreateManualRecordDto;
}
export type CreateManualRecordResponse = SerializedManualRecord;

export interface UpdateManualRecordArg {
  manualRecordId: SerializedManualRecord['_id'];
  payload: UpdateManualRecordDto;
}
export type UpdateManualRecordResponse = SerializedManualRecord;

export interface DeleteManualRecordArg {
  manualRecordId: SerializedManualRecord['_id'];
}
export type DeleteManualRecordResponse = void;

export class BackendGatewayManualRecordsApiClient extends BaseApiClient {
  constructor(jwt: string) {
    super('enmon-tools/manual-records', undefined, jwt);
  }

  public async find(filter: GetManualRecordsArgs = {}): Promise<GetManualRecordsResponse> {
    const params = new URLSearchParams();

    if (filter.meters) params.append('meters', joinIfArray(filter.meters));
    if (filter.page) params.append('page', String(filter.page));
    if (filter.pageSize) params.append('pageSize', String(filter.pageSize));

    const response = await this.axios.get<GetManualRecordsResponse>('', {
      params: params.toString(),
    });

    return response.data;
  }

  public async create({ payload }: CreateManualRecordArg): Promise<CreateManualRecordResponse> {
    const response = await this.axios.post<CreateManualRecordResponse>('', payload);
    return response.data;
  }

  public async update({ manualRecordId, payload }: UpdateManualRecordArg): Promise<UpdateManualRecordResponse> {
    const response = await this.axios.patch<UpdateManualRecordResponse>(manualRecordId, payload);
    return response.data;
  }

  public async delete({ manualRecordId }: DeleteManualRecordArg): Promise<DeleteManualRecordResponse> {
    await this.axios.delete<DeleteManualRecordResponse>(manualRecordId);
  }
}
